import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Settings, LayoutDashboard, Users, QrCode } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const API_BASE = API_URL.replace('/api', '');

export default function Header() {
  const { user, company, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Le tenant historique DNF garde son identité exacte (logo + nom).
  // Les autres tenants affichent leur propre logo/nom ; à défaut, la marque Jalonne.
  const isDnf = company?.slug === 'dnf-sas';
  const name = isDnf ? 'DNF sas' : (company?.name || 'Jalonne');

  let brandMark;
  if (isDnf) {
    brandMark = <img src="/logo.png" alt="DNF" style={{ height: 36, width: 'auto', mixBlendMode: 'multiply' }} />;
  } else if (company?.logo) {
    brandMark = <img src={`${API_BASE}/uploads/${company.logo}`} alt={name} style={{ height: 36, width: 'auto' }} />;
  } else {
    brandMark = (
      <span style={{
        width: 34, height: 34, borderRadius: 9, background: 'var(--primary)', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <QrCode size={20} />
      </span>
    );
  }

  return (
    <header className="app-header">
      <div className="container">
        <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          {brandMark}
          <h1 style={{ margin: 0 }}>{name}</h1>
        </Link>
        <nav className="header-nav">
          <span style={{ fontSize: '0.85rem', color: 'var(--text-light)' }}>
            {user?.name}
          </span>
          <Link to="/dashboard" className="btn btn-sm"><LayoutDashboard size={14} /> Chantiers</Link>
          <Link to="/partners" className="btn btn-sm"><Users size={14} /> Intervenants</Link>
          <Link to="/settings" className="btn btn-sm"><Settings size={14} /> Réglages</Link>
          <button className="btn btn-sm" onClick={handleLogout}><LogOut size={14} /> Déconnexion</button>
        </nav>
      </div>
    </header>
  );
}
